import React from 'react'

function Rating({rating}) {
  return rating
}

export default Rating;



// WEBPACK FOOTER //
// ./src/components/resume/Rating.jsx